import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { Button, DialogTitle, FormControl, Select } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import MenuItem from '@mui/material/MenuItem';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';

const CodingProfileMappingModal = ({
  open,
  typeData,
  handleClose,
  reFetch,
  item,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [value, setValue] = useState(null);

  const submitHandler = () => {
    axiosClient
      .put('/SettingProduct/CoddingProfile/CoddingMappingUpdate', {
        params: {
          ProfileGuid: value.key,
        },
      })
      .then(res => {
        reFetch();
        handleClose();
        enqueueSnackbar('عملیات موفقیت آمیز بود', { variant: 'successr' });
      })
      .catch(e => {
        console.error(e);
        enqueueSnackbar('مشکلی رخ داده', { variant: 'error' });
        handleClose();
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        setValue(null);
      }}
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>ویرایش مپ پرفایل</DialogTitle>

      <DialogContent sx={{ width: '480px' }}>
        <FilledWrapper>
          <FilledLabel>مپ پروفایل</FilledLabel>
          <FormControl
            variant="standard"
            sx={{ width: '100%', paddingRight: 3 }}
            // error={!codeType && emptyError}
          >
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={value}
              onChange={e => setValue(e.target.value)}
            >
              {typeData?.length ? (
                typeData?.map(code => (
                  <MenuItem
                    value={code.key}
                    key={code.key}
                    sx={{ direction: 'rtl' }}
                  >
                    {code.value}
                  </MenuItem>
                ))
              ) : (
                <p style={{ textAlign: 'center' }}>موردی یافت نشد</p>
              )}
            </Select>
          </FormControl>
        </FilledWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={() => {
            handleClose();
            setValue(null);
          }}
          variant="contained"
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitHandler}
          disabled={value == null}
        >
          ویرایش
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

const FilledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledLabel = styled.label`
  width: 130px;
`;

export default CodingProfileMappingModal;
